module.exports = __webpack_public_path__ + "static/media/kv-virtual-cricket-m.14050138.jpg";